import React from 'react';
import { FamilyMember, MedicalConditionStatus } from 'store/modules/subscriber-imq/types';
import { observer } from 'mobx-react-lite';
import { MedicalConditionStatusTag } from '../MedicalConditionStatusTag';
import {
  AffectedPeopleStyled,
  ConditionNameStyled,
  ManageConditionButtonStyled,
  MedicalConditionEntryStyled,
} from './styles';

interface Props {
  status: MedicalConditionStatus;
  conditionName: string;
  affectedMembers: FamilyMember[];
  manageCondition: (conditionName: string, affectedMembers: FamilyMember[]) => void;
}

export const MedicalConditionEntry: React.FC<Props> = observer(
  ({ status, conditionName, affectedMembers, manageCondition }) => {
    return (
      <MedicalConditionEntryStyled $status={status}>
        <ConditionNameStyled>{conditionName}</ConditionNameStyled>
        <AffectedPeopleStyled>{affectedMembers.map((member) => member.name).join(', ')}</AffectedPeopleStyled>
        <MedicalConditionStatusTag status={status} />
        <ManageConditionButtonStyled
          type="text"
          color="primary"
          size="small"
          uppercase
          onClick={(): void => manageCondition(conditionName, affectedMembers)}
        >
          Manage Condition
        </ManageConditionButtonStyled>
      </MedicalConditionEntryStyled>
    );
  },
);
